<template>
  <component
    :is="element"
    role="option"
    :title="title"
    :class="[
      $style.item, {
        [$style.hovered]: hovered,
        [$style.disabled]: disabled,
        [$style.multiline]: multiline
      }
    ]"
  >
    <div :class="$style.visuals">
      <div
        v-if="showCheckbox"
        :class="$style.checkbox"
      >
        <slot name="checkbox">
          <base-icon
            v-if="selected"
            type="checked-item-mark-new"
          />
        </slot>
      </div>
      <slot name="icon">
        <base-icon
          v-if="icon"
          :type="icon"
        />
      </slot>
    </div>
    <slot
      name="title"
      :title="title"
    >
      <!-- @mousedown.prevent блокирует инициацию селекта, почему не user-select: none? да потому что сафари - https://bugs.webkit.org/show_bug.cgi?id=278455. -->
      <p
        :class="$style.title"
        @mousedown.prevent
      >
        {{ title }} <slot name="title-hint" />
      </p>
    </slot>
    <div
      v-if="description"
      :class="$style.description"
      :title="description"
    >
      {{ description }}
    </div>
    <slot name="after-content" />
  </component>
</template>

<script setup lang="ts">
import BaseIcon from '../../legacy/ui/base-icon/icon.vue';

type Props = {
  element?: 'div' | 'a';
  title?: string;
  description?: string;
  showCheckbox?: boolean;
  icon?: string;
  hovered?: boolean;
  selected?: boolean;

  disabled?: boolean;
  multiline?: boolean;
};

const { showCheckbox = true, element = 'div' } = defineProps<Props>();
</script>

<style module>
.item {
  padding: 8px;
  border-radius: 8px;
  display: grid;
  grid-template-columns: max-content auto max-content;
  gap: 0 8px;
  overflow: hidden;
  line-height: 24px;
  font-size: 15px;
  color: $black;
  cursor: pointer;
  user-select: none;
}

.visuals {
  display: flex;
  gap: 8px;
  align-items: center;
}

.hovered {
  background-color: $black-7;
}

.disabled{
  opacity: 0.3;
  pointer-events: none;
}

.checkbox{
  width: 16px;
  height: 22px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: flex-end;
}

.title, .description {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  grid-column: 2;
  user-select: text;
}
.description {
  color: $gray-600;
}

.multiline {
  .title, .description {
    white-space: unset;
  }
}
</style>

<i18n lang="json">{}</i18n>
